/**
 * Toggle for mobile submenu.
 */
const $ = window.jQuery;

export default {
  attach: function (context, settings) {
    const responsiveSubmenuItems_once = once('resposive-submenu-toggle-once',
      '.nrw-menu-header-responsive__block .nrw-menu-header-submenu .nrw-menu-header-responsive__title',
      context);

    $(responsiveSubmenuItems_once).each(function () {
      let $menuItem = $(this);
      let $toggle = $menuItem.find('> i');
      let $submenu = $menuItem.find('> ul.nrw-menu-header-responsive__content');

      $submenu.hide();
      $menuItem.addClass('is-closed');
      $toggle.attr('fas fa-angle-down pull-right action fa-solid');

      $toggle.on('click', function() {
        $submenu.toggle();
        $menuItem.toggleClass('is-closed');
      });
    });
  },
};
